const defaultState = [
  // {
  //   id: 1,
  //   endpoint: 'https://billetten.dk/api/debitors',
  //   closed: false
  // },
  // {
  //   id: 2,
  //   endpoint: 'https://billetten.dk/api/annual',
  //   closed: false
  // },
  // {
  //   id: 3,
  //   endpoint: 'https://billetten.dk/api/payments',
  //   closed: false
  // }
]

const errors = (state = defaultState, action) => {
  switch (action.type) {
    case 'CREATE_ERROR': {
      const { endpoint } = action.payload

      return [
        ...state,
        {
          id: state.length + 1,
          endpoint,
          closed: false
        }
      ]
    }
    case 'DELETE_ERROR': {
      return state.filter(error => error.id !== action.payload)
    }
    default: {
      return state
    }
  }
}

export default errors
